/*************************************************************************
 *
 * COMPRO CONFIDENTIAL
 * __________________
 *
 *  [2015] - [2020] Compro Technologies Private Limited
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Compro Technologies Private Limited. The
 * intellectual and technical concepts contained herein are
 * proprietary to Compro Technologies Private Limited and may
 * be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Compro Technologies Pvt. Ltd..
 ***************************************************************************/

/***********************************************************
 * comproDLS SDK PUSHX Adaptor
 * Functions for calling PUSHX.
 ************************************************************/


var q = require('q');
var request = require('superagent');
var Agent = require('agentkeepalive');

var helpers = require('../../helpers');
var pubnubClientWrapper = require('./pubnubClientWrapper');
var DLSError = helpers.errors.DLSError;

/*********************************
 * Setting Up Module Entry Point
 **********************************/
module.exports = pushX;

var keepaliveAgent = new Agent({
  timeout: 60000,
  freeSocketTimeout: 30000
});

/*********************************
 * Public Function definitions
 **********************************/
function pushX() {
  var _pubnubClientWrapper = pubnubClientWrapper();
  return {
    "connect": _connect.bind(this, _pubnubClientWrapper),
    "cleanup": _cleanup.bind(this, _pubnubClientWrapper),
    "grantByUserOrgId": grantByUserOrgId.bind(this),
    "grantByAccountId": grantByAccountId.bind(this),
    "grantByAccountIdOnExtUserId": grantByAccountIdOnExtUserId.bind(this),
    "grantV2": grantV2.bind(this),
    "getPushedEvents": getPushedEvents.bind(this)
  };
}

/*********************************
 * Public Function definitions
 **********************************/

function _connect(pubnubCW, options) {
  var bpubnubV7 = true; // If pubnub v7 or higher in package.json, set it true
  if (bpubnubV7 && !options.userid) {
    var err = {};
    err.message = err.description = 'Mandatory parameter userid not found in request options.';
    err = new DLSError(helpers.errors.ERROR_TYPES.PUSHX_ERROR, err);
    throw err;
  }

  // Adding SSL flag
  return pubnubCW.setup({
    'userid': options.userid,
    'accountid': options.accountid,
    'token': options.token,
    'pubnub': {
      'publishKey': options.publishKey,
      'subscribeKey': options.subscribeKey,
      'ssl': true,
      'suppressLeaveEvents': true
    }
  });
}

function _cleanup(pubnubCW) { pubnubCW.cleanup(); }

/*options = {}*/
function grantByUserOrgId(options) {
  var dfd = q.defer();  // Initializing promise
  var allowedChannels = ['jobs', 'systemevents'];
  var baseChannelName = "o-" + this.orgId + "\\$u-" + this.token.access_token + "\\$";
  var patterns = [];
  for(var i in allowedChannels) {
    var channelName = baseChannelName + allowedChannels[i] + "\\..*";
    patterns.push(channelName);
  }
  options.channels = {};
  options.channels.patterns = patterns;
  grantV2.call(this, options)
  .then(function (res) {
    dfd.resolve(res);
  })
  .catch(function(err) {
    dfd.reject(err);
  });
  return dfd.promise;
}

/*options = {
    accountId: <accountid>,
    refId: <extRefId>
}*/
function grantByAccountId(options) {
	var err ={};
  var dfd = q.defer();  // Initializing promise

  if(options.accountId && options.refId) {
    var channel = "a-" + options.accountId + "$refid." + options.refId;
    var exactMatch = [channel];
    options.channels = {};
    options.channels.exactMatch = exactMatch;
    grantV2.call(this, options)
    .then(function (res) {
      dfd.resolve(res);
    })
    .catch(function(err) {
      dfd.reject(err);
    });
  }
  else {
    err.message = err.description = "Required parameter ['accountId', 'refId'] " +
                                    "not found in request options";
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }
  return dfd.promise;
}

/*options = {
    accountId: <accountid>,
    extUserId: <extUserId>, //mandatory
}*/
function grantByAccountIdOnExtUserId(options) {
	var err ={};
  var dfd = q.defer();  // Initializing promise

  if(options.accountId && options.extUserId) {
    var channel = "a-" + options.accountId + "$u-" + options.extUserId;
    var exactMatch = [channel];
    options.channels = {};
    options.channels.exactMatch = exactMatch;
    grantV2.call(this, options)
    .then(function (res) {
      dfd.resolve(res);
    })
    .catch(function(err) {
      dfd.reject(err);
    });
  }
  else {
    err.message = err.description = "Required parameter ['accountId', 'extUserId'] " +
                                    "not found in request options";
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }
  return dfd.promise;
}

/**
 * This function provides grant token on given channels
 * @param { channels: { exactMatch: [], patterns: [] } } options 
 * @returns { token, publishKey, subscribeKey }
 */
function grantV2(options) {
  var self = this, err = {};
  var dfd = q.defer();
  var body = { channels: {} };
  if(!options.channels) {
    err.message = err.description = "channels not given in input body.";
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
    return dfd.promise;
  }
  body.channels = options.channels;
  // Passed all validations, Construct API url
  var url = self.config.DEFAULT_HOSTS.PUSHX + self.config.PUSHX_API_URLS.grantV2;
  // Setup request with URL and Params
  var requestAPI = request.post(url)
                    .set('Content-Type', 'application/json')
                    .set('Accept', 'application/json');
  if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

  requestAPI.send(body);
  requestAPI.end(function(err, response) {
    if(err) {
      err = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, err);
      dfd.reject(err);
    }
    else { dfd.resolve(response.body); }
  });
  return dfd.promise;
}

/**
 * @param {
 *  *accountid: "string",
 *  *channelName: "string",
 *  *starttime: number,
 *  *endtime: number
 * } options
 */
function getPushedEvents(options) {
  var self = this;
  var dfd = q.defer();  // Initializing promise
  var accountid = options.accountid,
    channelname = options.channelname,
    starttime = options.starttime,
    endtime = options.endtime;

  if (accountid && channelname && starttime && endtime) {
    // Passed all validations, Construct API url
    var url = self.config.DEFAULT_HOSTS.PUSHX + self.config.PUSHX_API_URLS.getPushedEvents;
    url = helpers.api.constructAPIUrl(url, { accountId: accountid });

    // Setup request with URL and Params
    var params = {channelname: channelname, starttime: starttime, endtime: endtime};
    var requestAPI = request.get(url).query(params);
    if(self.traceid) { requestAPI.set('X-Amzn-Trace-Id', self.traceid); }

    requestAPI
      .agent(keepaliveAgent)
      .end(function(error, response) {
        if (error) {
          error = new DLSError(helpers.errors.ERROR_TYPES.API_ERROR, error);
          dfd.reject(error);
        } else {
          dfd.resolve(response.body);
        }
    });
  }
  else {
    var err = {};
    err.message = err.description = 'Mandatory parameters [accountId, channelname,' +
      ' starttime, endtime] not found in request options';
    err = new DLSError(helpers.errors.ERROR_TYPES.SDK_ERROR, err);
    dfd.reject(err);
  }
  return dfd.promise;
}
